import { render, staticRenderFns } from "./screen-cells.vue?vue&type=template&id=31400fdf&scoped=true&"
import script from "./screen-cells.vue?vue&type=script&lang=js&"
export * from "./screen-cells.vue?vue&type=script&lang=js&"
import style0 from "./screen-cells.vue?vue&type=style&index=0&id=31400fdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31400fdf",
  null
  
)

export default component.exports